import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function DifferentiationSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 bg-brand-white relative border-t border-brand-gold/10" data-id="element-13">
      <div className="max-w-6xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-15">
          <h2 className="font-heading font-bold text-3xl md:text-5xl uppercase tracking-tight text-brand-text" data-id="element-16">
            Esto no es otra agencia prometiendo leads
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-17">
          {/* Others */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-brand-charcoal border border-red-200 p-8 rounded-xl" data-id="element-18">
            <h3 className="font-heading font-bold text-xl text-brand-text-muted mb-6 uppercase tracking-wide border-b border-gray-200 pb-4" data-id="element-19">
              Otras Opciones
            </h3>
            <ul className="space-y-6" data-id="element-20">
              {['Prometen resultados sin conocer seguros', 'Usan fórmulas recicladas', 'Entregan campañas sin estructura', 'No acompañan la activación del recluta'].map((item, i) => <li key={i} className="flex items-start" data-id="element-21">
                  <XIcon className="w-6 h-6 text-red-500 shrink-0 mr-4 mt-0.5" data-id="element-22" />
                  <span className="text-brand-text-muted" data-id="element-23">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Reclutas Digitales */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-brand-white border border-brand-gold p-8 rounded-xl shadow-[0_0_30px_rgba(200,149,43,0.1)]" data-id="element-24">
            <h3 className="font-heading font-bold text-xl text-brand-gold mb-6 uppercase tracking-wide border-b border-brand-gold/20 pb-4" data-id="element-25">
              Reclutas Digitales
            </h3>
            <ul className="space-y-6" data-id="element-26">
              {['Está enichado en seguros', 'Habla tu idioma', 'Conoce tu negocio', 'Te da estructura documentada', 'Te ayuda a construir una operación propia'].map((item, i) => <li key={i} className="flex items-start" data-id="element-27">
                  <CheckIcon className="w-6 h-6 text-brand-gold shrink-0 mr-4 mt-0.5" data-id="element-28" />
                  <span className="text-brand-text font-medium" data-id="element-29">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}